/**
 * gs-cart-suggest — bouton "+" des suggestions du tiroir ("Complétez votre panier").
 * Ajoute l'article en AJAX (/cart/add.js) avec le rendu de section, puis redispatche
 * l'événement 'cart:update' du thème → cart-items-component re-morph le tiroir
 * (articles + barre de récompenses + suggestions mises à jour). Écouteur délégué (survit aux re-rendus).
 */
(function () {
  if (window.__gsCartSuggestInit) return;
  window.__gsCartSuggestInit = true;

  function cartSectionId() {
    var c = document.querySelector('cart-items-component');
    return c && c.dataset ? c.dataset.sectionId : null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var btn = target.closest('button.gs-sug__add');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var container = btn.closest('.gs-sug');
    var addUrl = (container && container.getAttribute('data-add-url')) || '/cart/add';
    var sectionId = cartSectionId();

    btn.classList.add('is-loading');
    btn.disabled = true;

    var body = { id: variantId, quantity: 1 };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { sections: data.sections, source: 'gs-cart-suggest' } },
            })
          );
        } else {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      })
      .catch(function (err) {
        console.error('[gs-cart-suggest]', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();
